import React from 'react';
import { ButtonsContainer, FormContainer } from '../../components/Layout';
import { Button, FieldsMapper, Spinner } from '../../components/Common';
import ModalContent from '../../components/Common/Modal/ModalContent';
import ModalTitle from '../../components/Common/Modal/ModalTitle';
import ModalHeader from '../../components/Common/Modal/ModalHeader';
import { __ } from '../../services/translation';
import { apiTable, modal } from '../../actions';
import { useDispatch } from 'react-redux';
import ItfApiForm from '../../components/Common/TrackedItfApiForm';
import { OfferNameReq } from 'profilpol-types';
import { successNotification } from '../../actions/notifications';
import { ButtonType } from '../../components/Common/Button';
import ApiService from '../../services/api-service';
import { formOnTranslateString } from '../../utils/trans-form';

interface Props {
  offerId: string;
}

const OfferName = ({ offerId }: Props) => {
  const dispatch = useDispatch();

  return (
    <ModalContent>
      <ModalHeader>
        <ModalTitle title="offer.edit_name" />
      </ModalHeader>
      <FormContainer>
        <ItfApiForm
          unsavedScope="modal"
          formId="offerNameForm"
          schemaMayBeDynamic={true}
          schemaCacheEnabled={false}
          loadingInfoAboveContent
          loadingInfo={<Spinner overlay halfTransparent />}
          sendDelay={200}
          requiredIndicator="*"
          schemaFetcher={() =>
            ApiService.loadForm(`offer/form/offer-name/${offerId}`)
          }
          sendFetcher={(formId: string, values: OfferNameReq) => {
            return ApiService.sendForm(
              `offer/name/${offerId}`,
              values,
              'PATCH',
              null
            );
          }}
          submitButton={(loading: boolean) => (
            <ButtonsContainer>
              <Button
                disabled={loading}
                small
                type={ButtonType.Button}
                danger
                click={() => dispatch(modal.hideModal())}
                text={'application.cancel'}
              />
              <Button
                disabled={loading}
                small
                type={ButtonType.Submit}
                success
                text={'application.save'}
              />
            </ButtonsContainer>
          )}
          onRenderFullField={FieldsMapper}
          onSavedSuccessfully={() => {
            dispatch(successNotification('offer.successfully_changed_name'));
            dispatch(apiTable.refreshApiTable());
            dispatch(modal.hideModal());
          }}
          onTranslateString={formOnTranslateString}
        />
      </FormContainer>
    </ModalContent>
  );
};

export default OfferName;
